import styled, { keyframes } from "styled-components";

import { Link } from "react-router-dom";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;

  display: flex;
  justify-content: center;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const typing = keyframes`
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
`;

export const Content = styled.div`
  width: 80%;
  height: fit-content;
  margin: 10px;
  z-index: 1;

  padding: 30px;
  border-radius: 10px;

  animation: ${fadeIn} 0.4s;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  * {
    width: 100%;
  }

  > h1 {
    align-self: flex-start;
    margin: 15px 0px;
    color: var(--primary);
    white-space: nowrap;
    overflow: hidden;

    font-size: clamp(8px, 8px + 1vw, 30px);

    animation: ${typing} 1.2s steps(50) 0.5s normal both;
  }

  > header {
    > h1,
    h3 {
      margin: 5px;
    }
  }

  @media (max-width: 425px) {
    width: 90%;
    margin: 40px 10px;
  }
`;

export const Card = styled.div`
  min-width: calc(100% - 45px);
  height: 100%;
  padding: 20px;
  background-color: var(--white);
  flex: 0 1 calc(25% - 1em);

  box-shadow: 2px 2px 5px;
  /* border: 1px solid var(--gray); */
  border-radius: 10px;

  transition: 0.1s;

  > header {
    display: flex;
    align-items: center;

    margin-bottom: 10px;

    > h2 {
      font-size: 22px;

      transition: 0.2s;
    }

    > p {
      text-align: right;
    }
  }

  cursor: pointer;

  > h2 {
    margin-bottom: 5px;

    transition: 0.2s;
  }

  > h3 {
    color: var(--gray);
    margin-bottom: 10px;
  }

  > label {
    margin-bottom: 2px;
    font-weight: bold;
  }

  > p {
    color: var(--gray);
    font-size: 18px;
    margin-bottom: 10px;

    > em {
      color: var(--darkGreen);
      font-style: unset;
      font-size: 28px;
      font-weight: bold;
    }

    @media (max-width: 425px) {
      font-size: 18px;
    }
  }

  :hover {
    box-shadow: 4px 4px 10px;

    transform: scale(1.05);

    > h2 {
      color: var(--primary);
    }

    > header h2 {
      color: var(--primary);
    }
  }
  :active {
    opacity: 0.4;
  }
`;
export const CardContainer = styled.section`
  width: 96%;
  display: grid;
  justify-items: stretch;
  grid-gap: 15px;
  grid-template-columns: ${({ umItem }) =>
    umItem
      ? "repeat(auto-fit, minmax(250px, 50%))"
      : "repeat(auto-fit, minmax(250px, 1fr))"};
  place-items: center;

  animation: ${fadeIn} 0.4s;
`;

export const ListContainer = styled.section`
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-gap: 15px;
  grid-template-columns: 96%;
`;

export const CardList = styled(Card)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    gap: 30px;
    flex-direction: column;

  }

  > header {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;

    margin-bottom: 10px;

    > h2 {
      flex: 1;
    }

    > p {
      text-align: left;
    }
    @media (max-width: 420px) {
      > h2 {
        font-size: 16px;
      }

      > p {
        font-size: 12px;
      }
    }
  }

  > div {
    white-space: nowrap;
    width: fit-content;
    height: fit-content;
    text-align: right;
  }
`;

export const LinkMenu = styled(Link)`
  color: var(--black);
  width: 100px;

  text-decoration: none;
  font-weight: bold;

  :hover {
    opacity: 0.8;
  }
  :active {
    opacity: 0.6;
  }
`;

export const FloatButton = styled("div")`
  width: 75px;
  height: 75px;
  bottom: 17px;
  right: 0;
  margin: 10px;
  position: fixed;
  z-index: 9;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  font-size: 35px;
  color: var(--white);
  font-weight: bold;
  border-radius: 37px;
  background-color: #a00;
  box-shadow: 0px 0px 5px var(--overlay);

  transition: width .4s,  box-shadow 0.8s;

  > p {
    white-space: nowrap;
    overflow: hidden;
  }

  :hover {
    box-shadow: 0px 0px 10px  black;
    font-size: 18px;
    width: 200px;
  }
`;
